export enum Section {
  about = 'About',
  portfolio = 'Portfolio',
}

export enum Product {
  ghost = 'Ghost',
}

export enum ThemeMode {
  light = 'light',
  dark = 'dark',
}
